import React, { useState } from 'react';
import { getShipments } from '../../api';
import InsideImagesModal from '../../components/InsideImagesModal';

const WAREHOUSE_NAMES = {
  'Kho 1': 'Kho 4450 Van',
  'Kho 2': 'Kho 7320 Cal',
  'Kho 3': 'Kho 3838/135 Cal',
  'ARBOURRIDGE': 'ARBOURRIDGE (Cal)',
  'Kho 4': 'Kho 465 Toronto',
  'Kho Surrey': 'Kho Surrey',
};
const warehouseName = (w) => WAREHOUSE_NAMES[w] || w || '—';

export default function FindCodes() {
  const [input, setInput] = useState('');
  const [results, setResults] = useState(null);
  const [loading, setLoading] = useState(false);
  const [imageModal, setImageModal] = useState(null);
  const [insideModal, setInsideModal] = useState(null);

  const handleSearch = async () => {
    const codes = input.trim().split(/\s+/).filter(Boolean);
    if (!codes.length) return;
    setLoading(true);
    try {
      const data = await Promise.all(codes.map(async code => {
        try {
          const list = await getShipments({ search: code });
          const match = list.find(s =>
            (s.tracking_code && s.tracking_code.toLowerCase() === code.toLowerCase()) ||
            (s.customer_order && s.customer_order.toLowerCase() === code.toLowerCase())
          );
          return { code, shipment: match || null };
        } catch (e) {
          return { code, shipment: null };
        }
      }));
      setResults(data);
    } finally { setLoading(false); }
  };

  const foundCount = results ? results.filter(r => r.shipment).length : 0;

  return (
    <div>
      <style>{`
        .fc-input:focus, .fc-ta:focus { outline:none; border-color:var(--accent)!important; box-shadow:0 0 0 3px var(--accent-bg)!important; }
        .fc-btn:hover:not(:disabled) { background:var(--bg-elevated)!important; border-color:var(--accent)!important; }
      `}</style>

      <div style={s.topbar}>
        <div className="page-eyebrow">MANAGEMENT</div><h1 className="page-title">Find codes (batch lookup)</h1>
      </div>

      <div style={s.card}>
        <div style={{fontSize:11,color:'var(--text-muted)',marginBottom:10,lineHeight:1.5}}>
          Paste multiple tracking codes or customer orders here, separated by spaces or newlines. Searches all warehouse data.
        </div>
        <textarea className="fc-ta"
          rows={4}
          placeholder="vd:&#10;ABC123 DEF456 GHI789&#10;XYZ555"
          value={input}
          onChange={e=>setInput(e.target.value)}
          style={s.textarea}
        />
        <button className="fc-btn" onClick={handleSearch} disabled={loading||!input.trim()}
          style={{...s.searchBtn,opacity:(loading||!input.trim())?0.5:1}}>
          {loading ? '⏳ Searching...' : '🔍 Search'}
        </button>
      </div>

      {results && (
        <>
          <div style={{fontSize:11,color:'var(--text-muted)',marginBottom:10,letterSpacing:1,textTransform:'uppercase',fontWeight:700}}>
            Results — {foundCount}/{results.length} codes in warehouse
          </div>
          <div style={{display:'flex',flexDirection:'column',gap:8}}>
            {results.map((r, i) => <ResultRow key={i} r={r} onImageClick={setImageModal} onInsideClick={(id,t)=>setInsideModal({id,tracking:t})} />)}
          </div>
        </>
      )}

      {imageModal && (
        <div onClick={()=>setImageModal(null)}
          style={{position:'fixed',inset:0,background:'rgba(15,23,42,0.55)',display:'flex',alignItems:'center',justifyContent:'center',zIndex:200,padding:20}}>
          <img src={imageModal} alt="label" onClick={e=>e.stopPropagation()}
            style={{maxWidth:'100%',maxHeight:'90vh',borderRadius:8,border:'1px solid rgba(15,23,42,0.10)'}} />
          <button onClick={()=>setImageModal(null)}
            style={{position:'absolute',top:20,right:20,background:'rgba(15,23,42,0.25)',border:'1px solid rgba(15,23,42,0.14)',color:'#fff',borderRadius:'50%',width:40,height:40,fontSize:20,cursor:'pointer'}}>×</button>
        </div>
      )}
      {insideModal && (
        <InsideImagesModal shipmentId={insideModal.id} tracking={insideModal.tracking} onClose={()=>setInsideModal(null)} />
      )}
    </div>
  );
}

function ResultRow({ r, onImageClick, onInsideClick }) {
  const { code, shipment: sh } = r;
  const [expanded, setExpanded] = useState(false);

  if (!sh) {
    return (
      <div style={{padding:'12px 16px',background:'rgba(220,38,38,0.08)',border:'1px solid rgba(220,38,38,0.20)',borderRadius:10}}>
        <div style={{fontVariantNumeric:"tabular-nums",fontWeight:600,fontWeight:700,fontSize:13,color:'var(--text-secondary)',marginBottom:4}}>{code}</div>
        <div style={{fontSize:12,color:'#b91c1c',fontWeight:600}}>⏳ Not scanned yet</div>
      </div>
    );
  }

  return (
    <div style={{background:'var(--bg-tertiary)',border:'1px solid rgba(22,163,74,0.15)',borderRadius:10,overflow:'hidden'}}>
      <div onClick={()=>setExpanded(e=>!e)} style={{display:'flex',alignItems:'center',gap:12,padding:'12px 16px',cursor:'pointer'}}>
        {sh.image_url ? (
          <img src={sh.image_url} alt="label" onClick={e=>{e.stopPropagation();onImageClick(sh.image_url);}}
            style={{width:48,height:48,objectFit:'cover',borderRadius:6,border:'1px solid rgba(22,163,74,0.30)',flexShrink:0,cursor:'zoom-in'}} />
        ) : (
          <div style={{width:48,height:48,borderRadius:6,background:'var(--bg-tertiary)',border:'1px solid rgba(15,23,42,0.06)',display:'flex',alignItems:'center',justifyContent:'center',fontSize:20,opacity:0.2,flexShrink:0}}>📷</div>
        )}
        <div style={{flex:1,minWidth:0}}>
          <div style={{fontVariantNumeric:"tabular-nums",fontWeight:600,fontWeight:700,fontSize:13,color:'var(--accent)',marginBottom:3}}>{sh.tracking_code}</div>
          <div style={{fontSize:11,color:'var(--text-secondary)'}}>
            {sh.receiver_name||'—'}
            {sh.customer_code ? <span style={{color:'var(--color-info)',marginLeft:6,fontVariantNumeric:"tabular-nums",fontWeight:600,fontWeight:600}}>· {sh.customer_code}</span> : null}
            {' · '}{warehouseName(sh.warehouse)}
          </div>
        </div>
        <div style={{display:'flex',alignItems:'center',gap:6,flexShrink:0,flexWrap:'wrap',justifyContent:'flex-end'}}>
          <span style={{fontSize:10,fontWeight:700,color:'var(--color-success)',background:'rgba(22,163,74,0.10)',border:'1px solid rgba(22,163,74,0.22)',padding:'3px 8px',borderRadius:20}}>✅ In warehouse</span>
          {sh.flight_name && (
            <span style={{fontSize:10,fontWeight:700,color:sh.flight_status==='flown'?'var(--color-danger)':'var(--color-purple)',background:sh.flight_status==='flown'?'rgba(220,38,38,0.10)':'rgba(124,58,237,0.10)',border:`1px solid ${sh.flight_status==='flown'?'rgba(220,38,38,0.22)':'rgba(124,58,237,0.22)'}`,padding:'3px 8px',borderRadius:20}}>
              ✈ {sh.flight_name} · {sh.flight_status==='flown'?'Flown':'Pending'}
            </span>
          )}
          <span style={{color:'var(--text-muted)',fontSize:16}}>{expanded?'▲':'▼'}</span>
        </div>
      </div>
      {expanded && (
        <div style={{borderTop:'1px solid rgba(15,23,42,0.06)',padding:'12px 16px'}}>
          <div style={{display:'grid',gridTemplateColumns:'1fr 1fr 1fr',gap:'8px 16px',marginBottom:10}}>
            <F label="Customer Order" value={sh.customer_order} />
            <F label="Weight" value={sh.weight_kg?`${sh.weight_kg} KG`:null} green />
            <F label="Count (AI)" value={sh.can_count!=null?String(sh.can_count):null} />
            <F label="Customer" value={sh.customer_name?`${sh.customer_code||''} ${sh.customer_name}`:null} />
            <F label="Current location" value={warehouseName(sh.current_location||sh.warehouse)} />
            <F label="Scanned at" value={new Date(sh.scanned_at).toLocaleDateString('vi-VN')} />
          </div>
          <button onClick={()=>onInsideClick(sh.id, sh.tracking_code)}
            style={{background:'rgba(217,119,6,0.10)',border:'1px solid rgba(217,119,6,0.22)',borderRadius:6,padding:'6px 12px',fontSize:11,fontWeight:600,color:'var(--color-warning)',cursor:'pointer'}}>
            📦 View inside photos
          </button>
        </div>
      )}
    </div>
  );
}

function F({ label, value, green }) {
  return (
    <div>
      <div style={{fontSize:9,fontWeight:700,color:'var(--text-muted)',textTransform:'uppercase',letterSpacing:1,marginBottom:3}}>{label}</div>
      <div style={{fontSize:12,color:green&&value?'var(--accent)':value?'var(--text-primary)':'var(--text-muted)',fontWeight:green?700:400}}>{value||'—'}</div>
    </div>
  );
}

const s = {
  topbar: { marginBottom:22 },
  pageLabel: { fontSize:10, fontWeight:700, color:'var(--text-muted)', letterSpacing:2, textTransform:'uppercase', marginBottom:4 },
  pageTitle: { fontSize:22, fontWeight:600, color:'var(--text-primary)', letterSpacing:-0.3 },
  card: { background:'var(--bg-tertiary)', border:'1px solid rgba(15,23,42,0.07)', borderRadius:12, padding:'20px 22px', marginBottom:20 },
  textarea: { width:'100%', background:'var(--bg-tertiary)', border:'1px solid rgba(15,23,42,0.08)', borderRadius:8, padding:'10px 12px', fontSize:13, color:'var(--text-primary)', fontVariantNumeric:"tabular-nums",fontWeight:600, resize:'vertical', boxSizing:'border-box', marginBottom:12, outline:'none' },
  searchBtn: { background:'var(--bg-tertiary)', color:'var(--text-primary)', border:'1px solid var(--accent-strong)', borderRadius:8, padding:'10px 22px', fontSize:13, fontWeight:700, cursor:'pointer', transition:'all 0.18s',  },
};
